import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import 'common/utils/domNormalizeHack'
import { Query, QueryKeys } from 'publisher/components/core/MatchMedia'
import BaseApp from 'publisher/entrypoints/base-app'
import configureStore from 'publisher/entrypoints/simple/configureStore'
import { selectors } from 'publisher/reducers/optInReducer'
import { selectors as pageSelectors } from 'publisher/reducers/pageReducer'
import { normalizeStringBoolean } from 'publisher/store'
import { initialiseAxiosInterceptors } from 'publisher/utils/registerAxiosInterceptors'
import { compose } from 'redux'
import { Level } from 'rollbar'
import { createEntityElement } from './create-entity-element'
import { createPage } from './create-page'

initialiseAxiosInterceptors()

declare global {
  interface Window {
    __ROLLBAR_LEVEL__?: Level
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
    __PRELOADED_STATE__?: any
  }
}

const rollbarReportLevel = window.__ROLLBAR_LEVEL__
const preloadedState = window.__PRELOADED_STATE__
window.__PRELOADED_STATE__ = undefined
// Allow the passed state to be garbage-collected
const isDesktop = window.matchMedia(Query[QueryKeys.DESKTOP]).matches
preloadedState.management.isDesktop = isDesktop
preloadedState.management.isMobile = normalizeStringBoolean(
  preloadedState.management.isMobile,
)
preloadedState.optIn.fields = selectors.getCustomerFields(preloadedState.optIn)

const store: any = configureStore(preloadedState)

if (pageSelectors.getCountryFieldId(preloadedState.page)) {
  preloadedState.optIn.fields.country = selectors.getCustomerCountry(
    preloadedState.optIn,
  )
}

// biome-ignore lint/style/noNonNullAssertion: <explanation>
const rootElement = document.getElementById('app')!

hydrateRoot(
  rootElement,
  <BaseApp
    createEntityElement={createEntityElement}
    createPage={createPage}
    store={store}
    rollbarReportLevel={rollbarReportLevel}
  />,
)
